/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { INITIALIZER_PROGRAM_ADDRESS } from '../programs';

/** Unauthorized: Unauthorized */
export const INITIALIZER_ERROR__UNAUTHORIZED = 0x1770; // 6000
/** InvalidPhase: Invalid phase */
export const INITIALIZER_ERROR__INVALID_PHASE = 0x1771; // 6001
/** InvalidAmount: Invalid amount */
export const INITIALIZER_ERROR__INVALID_AMOUNT = 0x1772; // 6002
/** InvalidVault: Invalid vault */
export const INITIALIZER_ERROR__INVALID_VAULT = 0x1773; // 6003
/** InvalidMint: Invalid mint */
export const INITIALIZER_ERROR__INVALID_MINT = 0x1774; // 6004
/** MathOverflow: Math overflow */
export const INITIALIZER_ERROR__MATH_OVERFLOW = 0x1775; // 6005
/** InvalidCurveParams: Invalid curve params */
export const INITIALIZER_ERROR__INVALID_CURVE_PARAMS = 0x1776; // 6006
/** SlippageExceeded: Slippage exceeded */
export const INITIALIZER_ERROR__SLIPPAGE_EXCEEDED = 0x1777; // 6007
/** CurveLiquidityInsufficient: Curve liquidity insufficient */
export const INITIALIZER_ERROR__CURVE_LIQUIDITY_INSUFFICIENT = 0x1778; // 6008
/** PayloadTooLarge: Payload too large */
export const INITIALIZER_ERROR__PAYLOAD_TOO_LARGE = 0x1779; // 6009
/** MigratorNotAllowlisted: Migrator not allowlisted */
export const INITIALIZER_ERROR__MIGRATOR_NOT_ALLOWLISTED = 0x177a; // 6010
/** HookNotAllowlisted: Hook not allowlisted */
export const INITIALIZER_ERROR__HOOK_NOT_ALLOWLISTED = 0x177b; // 6011
/** WrongMigrator: Wrong migrator program */
export const INITIALIZER_ERROR__WRONG_MIGRATOR = 0x177c; // 6012
/** WrongHook: Wrong hook program */
export const INITIALIZER_ERROR__WRONG_HOOK = 0x177d; // 6013
/** MigratorCpiFailed: Migrator CPI failed */
export const INITIALIZER_ERROR__MIGRATOR_CPI_FAILED = 0x177e; // 6014
/** HookCpiFailed: Hook CPI failed */
export const INITIALIZER_ERROR__HOOK_CPI_FAILED = 0x177f; // 6015
/** HookRejected: Hook rejected */
export const INITIALIZER_ERROR__HOOK_REJECTED = 0x1780; // 6016
/** BuyNotAllowed: Buy not allowed */
export const INITIALIZER_ERROR__BUY_NOT_ALLOWED = 0x1781; // 6017
/** SellNotAllowed: Sell not allowed */
export const INITIALIZER_ERROR__SELL_NOT_ALLOWED = 0x1782; // 6018
/** SellDisableNotAllowed: Sell disable not allowed once enabled */
export const INITIALIZER_ERROR__SELL_DISABLE_NOT_ALLOWED = 0x1783; // 6019
/** InvalidTradeDirection: Invalid trade direction */
export const INITIALIZER_ERROR__INVALID_TRADE_DIRECTION = 0x1784; // 6020
/** AllowlistFull: Allowlist full */
export const INITIALIZER_ERROR__ALLOWLIST_FULL = 0x1785; // 6021
/** InvalidInput: Invalid input */
export const INITIALIZER_ERROR__INVALID_INPUT = 0x1786; // 6022
/** LaunchLocked: Launch locked */
export const INITIALIZER_ERROR__LAUNCH_LOCKED = 0x1789; // 6025
/** InvalidCurveKind: Invalid curve kind */
export const INITIALIZER_ERROR__INVALID_CURVE_KIND = 0x178a; // 6026
/** CurveParamsInvalid: Curve params invalid */
export const INITIALIZER_ERROR__CURVE_PARAMS_INVALID = 0x178b; // 6027
/** RemainingAccountOverlap: Remaining account overlaps with protocol account */
export const INITIALIZER_ERROR__REMAINING_ACCOUNT_OVERLAP = 0x178c; // 6028
/** MissingRemainingAccountsCommitment: Missing remaining accounts commitment */
export const INITIALIZER_ERROR__MISSING_REMAINING_ACCOUNTS_COMMITMENT = 0x178d; // 6029
/** RemainingAccountsCommitmentMismatch: Remaining accounts commitment mismatch */
export const INITIALIZER_ERROR__REMAINING_ACCOUNTS_COMMITMENT_MISMATCH = 0x178e; // 6030
/** InvalidOracle: Invalid oracle account */
export const INITIALIZER_ERROR__INVALID_ORACLE = 0x178f; // 6031
/** MissingMetadataAccounts: Missing metadata accounts */
export const INITIALIZER_ERROR__MISSING_METADATA_ACCOUNTS = 0x1790; // 6032
/** InvalidMetadataProgram: Invalid metadata program */
export const INITIALIZER_ERROR__INVALID_METADATA_PROGRAM = 0x1791; // 6033
/** InvalidMetadataAccount: Invalid metadata account */
export const INITIALIZER_ERROR__INVALID_METADATA_ACCOUNT = 0x1792; // 6034
/** MetadataCpiFailed: Metadata CPI failed */
export const INITIALIZER_ERROR__METADATA_CPI_FAILED = 0x1793; // 6035
/** RemainingAccountSigner: Remaining accounts must not be signers */
export const INITIALIZER_ERROR__REMAINING_ACCOUNT_SIGNER = 0x1795; // 6037
/** RemainingAccountWritable: Remaining accounts must be readonly */
export const INITIALIZER_ERROR__REMAINING_ACCOUNT_WRITABLE = 0x1796; // 6038
/** MigrationIncomplete: Migration left vault funds behind */
export const INITIALIZER_ERROR__MIGRATION_INCOMPLETE = 0x1797; // 6039
/** InvalidFeeBeneficiary: Invalid fee beneficiary */
export const INITIALIZER_ERROR__INVALID_FEE_BENEFICIARY = 0x1798; // 6040
/** InvalidFeeShares: Invalid fee shares */
export const INITIALIZER_ERROR__INVALID_FEE_SHARES = 0x1799; // 6041
/** InvalidSwapFee: Invalid swap fee */
export const INITIALIZER_ERROR__INVALID_SWAP_FEE = 0x179a; // 6042
/** InvalidLaunchFeeState: Invalid launch fee state */
export const INITIALIZER_ERROR__INVALID_LAUNCH_FEE_STATE = 0x179b; // 6043
/** NoFeesToDistribute: No fees to distribute */
export const INITIALIZER_ERROR__NO_FEES_TO_DISTRIBUTE = 0x179c; // 6044
/** InvalidVestingConfig: Invalid vesting configuration */
export const INITIALIZER_ERROR__INVALID_VESTING_CONFIG = 0x179d; // 6045
/** VestingBalanceMismatch: Vesting vault balance changed by an unexpected amount */
export const INITIALIZER_ERROR__VESTING_BALANCE_MISMATCH = 0x179e; // 6046

export type InitializerError =
  | typeof INITIALIZER_ERROR__ALLOWLIST_FULL
  | typeof INITIALIZER_ERROR__BUY_NOT_ALLOWED
  | typeof INITIALIZER_ERROR__CURVE_LIQUIDITY_INSUFFICIENT
  | typeof INITIALIZER_ERROR__CURVE_PARAMS_INVALID
  | typeof INITIALIZER_ERROR__HOOK_CPI_FAILED
  | typeof INITIALIZER_ERROR__HOOK_NOT_ALLOWLISTED
  | typeof INITIALIZER_ERROR__HOOK_REJECTED
  | typeof INITIALIZER_ERROR__INVALID_AMOUNT
  | typeof INITIALIZER_ERROR__INVALID_CURVE_KIND
  | typeof INITIALIZER_ERROR__INVALID_CURVE_PARAMS
  | typeof INITIALIZER_ERROR__INVALID_FEE_BENEFICIARY
  | typeof INITIALIZER_ERROR__INVALID_FEE_SHARES
  | typeof INITIALIZER_ERROR__INVALID_INPUT
  | typeof INITIALIZER_ERROR__INVALID_LAUNCH_FEE_STATE
  | typeof INITIALIZER_ERROR__INVALID_METADATA_ACCOUNT
  | typeof INITIALIZER_ERROR__INVALID_METADATA_PROGRAM
  | typeof INITIALIZER_ERROR__INVALID_MINT
  | typeof INITIALIZER_ERROR__INVALID_ORACLE
  | typeof INITIALIZER_ERROR__INVALID_PHASE
  | typeof INITIALIZER_ERROR__INVALID_SWAP_FEE
  | typeof INITIALIZER_ERROR__INVALID_TRADE_DIRECTION
  | typeof INITIALIZER_ERROR__INVALID_VAULT
  | typeof INITIALIZER_ERROR__INVALID_VESTING_CONFIG
  | typeof INITIALIZER_ERROR__LAUNCH_LOCKED
  | typeof INITIALIZER_ERROR__MATH_OVERFLOW
  | typeof INITIALIZER_ERROR__METADATA_CPI_FAILED
  | typeof INITIALIZER_ERROR__MIGRATION_INCOMPLETE
  | typeof INITIALIZER_ERROR__MIGRATOR_CPI_FAILED
  | typeof INITIALIZER_ERROR__MIGRATOR_NOT_ALLOWLISTED
  | typeof INITIALIZER_ERROR__MISSING_METADATA_ACCOUNTS
  | typeof INITIALIZER_ERROR__MISSING_REMAINING_ACCOUNTS_COMMITMENT
  | typeof INITIALIZER_ERROR__NO_FEES_TO_DISTRIBUTE
  | typeof INITIALIZER_ERROR__PAYLOAD_TOO_LARGE
  | typeof INITIALIZER_ERROR__REMAINING_ACCOUNT_OVERLAP
  | typeof INITIALIZER_ERROR__REMAINING_ACCOUNTS_COMMITMENT_MISMATCH
  | typeof INITIALIZER_ERROR__REMAINING_ACCOUNT_SIGNER
  | typeof INITIALIZER_ERROR__REMAINING_ACCOUNT_WRITABLE
  | typeof INITIALIZER_ERROR__SELL_DISABLE_NOT_ALLOWED
  | typeof INITIALIZER_ERROR__SELL_NOT_ALLOWED
  | typeof INITIALIZER_ERROR__SLIPPAGE_EXCEEDED
  | typeof INITIALIZER_ERROR__UNAUTHORIZED
  | typeof INITIALIZER_ERROR__VESTING_BALANCE_MISMATCH
  | typeof INITIALIZER_ERROR__WRONG_HOOK
  | typeof INITIALIZER_ERROR__WRONG_MIGRATOR;

let initializerErrorMessages: Record<InitializerError, string> | undefined;
if (process.env.NODE_ENV !== 'production') {
  initializerErrorMessages = {
    [INITIALIZER_ERROR__ALLOWLIST_FULL]: `Allowlist full`,
    [INITIALIZER_ERROR__BUY_NOT_ALLOWED]: `Buy not allowed`,
    [INITIALIZER_ERROR__CURVE_LIQUIDITY_INSUFFICIENT]: `Curve liquidity insufficient`,
    [INITIALIZER_ERROR__CURVE_PARAMS_INVALID]: `Curve params invalid`,
    [INITIALIZER_ERROR__HOOK_CPI_FAILED]: `Hook CPI failed`,
    [INITIALIZER_ERROR__HOOK_NOT_ALLOWLISTED]: `Hook not allowlisted`,
    [INITIALIZER_ERROR__HOOK_REJECTED]: `Hook rejected`,
    [INITIALIZER_ERROR__INVALID_AMOUNT]: `Invalid amount`,
    [INITIALIZER_ERROR__INVALID_CURVE_KIND]: `Invalid curve kind`,
    [INITIALIZER_ERROR__INVALID_CURVE_PARAMS]: `Invalid curve params`,
    [INITIALIZER_ERROR__INVALID_FEE_BENEFICIARY]: `Invalid fee beneficiary`,
    [INITIALIZER_ERROR__INVALID_FEE_SHARES]: `Invalid fee shares`,
    [INITIALIZER_ERROR__INVALID_INPUT]: `Invalid input`,
    [INITIALIZER_ERROR__INVALID_LAUNCH_FEE_STATE]: `Invalid launch fee state`,
    [INITIALIZER_ERROR__INVALID_METADATA_ACCOUNT]: `Invalid metadata account`,
    [INITIALIZER_ERROR__INVALID_METADATA_PROGRAM]: `Invalid metadata program`,
    [INITIALIZER_ERROR__INVALID_MINT]: `Invalid mint`,
    [INITIALIZER_ERROR__INVALID_ORACLE]: `Invalid oracle account`,
    [INITIALIZER_ERROR__INVALID_PHASE]: `Invalid phase`,
    [INITIALIZER_ERROR__INVALID_SWAP_FEE]: `Invalid swap fee`,
    [INITIALIZER_ERROR__INVALID_TRADE_DIRECTION]: `Invalid trade direction`,
    [INITIALIZER_ERROR__INVALID_VAULT]: `Invalid vault`,
    [INITIALIZER_ERROR__INVALID_VESTING_CONFIG]: `Invalid vesting configuration`,
    [INITIALIZER_ERROR__LAUNCH_LOCKED]: `Launch locked`,
    [INITIALIZER_ERROR__MATH_OVERFLOW]: `Math overflow`,
    [INITIALIZER_ERROR__METADATA_CPI_FAILED]: `Metadata CPI failed`,
    [INITIALIZER_ERROR__MIGRATION_INCOMPLETE]: `Migration left vault funds behind`,
    [INITIALIZER_ERROR__MIGRATOR_CPI_FAILED]: `Migrator CPI failed`,
    [INITIALIZER_ERROR__MIGRATOR_NOT_ALLOWLISTED]: `Migrator not allowlisted`,
    [INITIALIZER_ERROR__MISSING_METADATA_ACCOUNTS]: `Missing metadata accounts`,
    [INITIALIZER_ERROR__MISSING_REMAINING_ACCOUNTS_COMMITMENT]: `Missing remaining accounts commitment`,
    [INITIALIZER_ERROR__NO_FEES_TO_DISTRIBUTE]: `No fees to distribute`,
    [INITIALIZER_ERROR__PAYLOAD_TOO_LARGE]: `Payload too large`,
    [INITIALIZER_ERROR__REMAINING_ACCOUNT_OVERLAP]: `Remaining account overlaps with protocol account`,
    [INITIALIZER_ERROR__REMAINING_ACCOUNTS_COMMITMENT_MISMATCH]: `Remaining accounts commitment mismatch`,
    [INITIALIZER_ERROR__REMAINING_ACCOUNT_SIGNER]: `Remaining accounts must not be signers`,
    [INITIALIZER_ERROR__REMAINING_ACCOUNT_WRITABLE]: `Remaining accounts must be readonly`,
    [INITIALIZER_ERROR__SELL_DISABLE_NOT_ALLOWED]: `Sell disable not allowed once enabled`,
    [INITIALIZER_ERROR__SELL_NOT_ALLOWED]: `Sell not allowed`,
    [INITIALIZER_ERROR__SLIPPAGE_EXCEEDED]: `Slippage exceeded`,
    [INITIALIZER_ERROR__UNAUTHORIZED]: `Unauthorized`,
    [INITIALIZER_ERROR__VESTING_BALANCE_MISMATCH]: `Vesting vault balance changed by an unexpected amount`,
    [INITIALIZER_ERROR__WRONG_HOOK]: `Wrong hook program`,
    [INITIALIZER_ERROR__WRONG_MIGRATOR]: `Wrong migrator program`,
  };
}

export function getInitializerErrorMessage(code: InitializerError): string {
  if (process.env.NODE_ENV !== 'production') {
    return (initializerErrorMessages as Record<InitializerError, string>)[code];
  }

  return 'Error message not available in production bundles.';
}

export function isInitializerError<TProgramErrorCode extends InitializerError>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode,
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    INITIALIZER_PROGRAM_ADDRESS,
    code,
  );
}
